import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AddSalario from "./pages/AddSalario";
import AddGasto from "./pages/AddGasto";
import Historial from "./pages/Historial";
import AddExtra from "./pages/AddExtra";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider, useAuth } from "./context/AuthContext";
import "./css/source.scss";
function AppRoutes() {
  const { isLoggedIn, checkingSession } = useAuth();
  if (checkingSession) {
    return <p>Cargando sesión...</p>; // puedes usar un spinner aquí
  }
  return (
    <>
      {isLoggedIn}
      <Routes>
        <Route path="/" element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/salario" element={<ProtectedRoute><AddSalario /></ProtectedRoute>} />
        <Route path="/gasto" element={<ProtectedRoute><AddGasto /></ProtectedRoute>} />
        <Route path="/extra" element={<ProtectedRoute><AddExtra /></ProtectedRoute>} />
        <Route path="/historial" element={<ProtectedRoute><Historial /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}
